import { CIcon } from '~/icons/types'

export const ciSailboat: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.704 18.288a.499.499 0 0 0-.366-.158h-1.242c-.329-2.169-2.308-13.059-9.291-16.213V.5a.5.5 0 0 0-1 0v.856a31.353 31.353 0 0 1-5.3 12.471.5.5 0 0 0 .4.8h4.894v3.508h-1.451l-2.094-1.27a.506.506 0 0 0-.259-.072H5.12a.5.5 0 0 0-.457.3l-1.088 2.449H2.96a.5.5 0 0 0-.445.273l-1.459 2.871a.5.5 0 0 0 .445.727l18.314-.073a.485.485 0 0 0 .2-.041c.149-.064 3.62-1.589 3.826-4.635a.5.5 0 0 0-.136-.376Zm-2.864-1.442a6.23 6.23 0 0 0-3.863-1.271 6.1 6.1 0 0 0-4.172 1.541V3.022c5.169 2.672 7.308 10.332 8.035 13.824Zm-.1 1.284h-7.52a4.943 4.943 0 0 1 3.758-1.555 4.945 4.945 0 0 1 3.76 1.555h.002ZM7.872 13.622a32.1 32.1 0 0 0 3.932-8.138v8.138H7.873ZM5.45 17.788h2.406l1.547.939-.814.815H4.67l.78-1.754Zm14.254 4.552-17.386.07.95-1.868h5.528a.5.5 0 0 0 .354-.147l1.266-1.265h12.34c-.466 1.876-2.593 2.992-3.052 3.21Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'sailboat',
  type: 'thin'
}
